import { __extends } from "tslib";
import { WebXRAbstractMotionController } from "./webXRAbstractMotionController";
import { Mesh } from "../../Meshes/mesh";
import { Quaternion } from "../../Maths/math.vector";
import { WebXRMotionControllerManager } from "./webXRMotionControllerManager";
/**
 * The motion controller class for the standard HTC-Vive controllers
 */
var WebXRHTCViveMotionController = /** @class */ (function (_super) {
    __extends(WebXRHTCViveMotionController, _super);
    /**
     * Create a new Vive motion controller object
     * @param scene the scene to use to create this controller
     * @param gamepadObject the corresponding gamepad object
     * @param handedness the handedness of the controller
     */
    function WebXRHTCViveMotionController(scene, gamepadObject, handedness) {
        var _this = _super.call(this, scene, HTCViveLayout[handedness], gamepadObject, handedness) || this;
        _this.profileId = "htc-vive";
        return _this;
    }
    WebXRHTCViveMotionController.prototype._getFilenameAndPath = function () {
        var filename = WebXRHTCViveMotionController.MODEL_FILENAME;
        var path = WebXRHTCViveMotionController.MODEL_BASE_URL;
        return {
            filename: filename,
            path: path,
        };
    };
    WebXRHTCViveMotionController.prototype._getModelLoadingConstraints = function () {
        return true;
    };
    WebXRHTCViveMotionController.prototype._processLoadedModel = function (_meshes) {
        var _this = this;
        this.getComponentIds().forEach(function (id) {
            var comp = id && _this.getComponent(id);
            if (comp) {
                comp.onButtonStateChangedObservable.add(function (component) {
                    if (!_this.rootMesh || _this.disableAnimation) {
                        return;
                    }
                    switch (id) {
                        case "xr-standard-trigger":
                            _this._modelRootNode.getChildren()[6].rotation.x = -component.value * 0.15;
                            return;
                        case "xr-standard-touchpad":
                            return;
                        case "xr-standard-squeeze":
                            return;
                    }
                }, undefined, true);
            }
        });
    };
    WebXRHTCViveMotionController.prototype._setRootMesh = function (meshes) {
        this.rootMesh = new Mesh(this.profileId + " " + this.handedness, this.scene);
        meshes.forEach(function (mesh) {
            mesh.isPickable = false;
        });
        this._modelRootNode = meshes[1];
        this._modelRootNode.parent = this.rootMesh;
        if (!this.scene.useRightHandedSystem) {
            this.rootMesh.rotationQuaternion = Quaternion.FromEulerAngles(0, Math.PI, 0);
        }
    };
    WebXRHTCViveMotionController.prototype._updateModel = function () {
        // no-op. model is updated using observables.
    };
    /**
     * The base url used to load the left and right controller models
     */
    WebXRHTCViveMotionController.MODEL_BASE_URL = "https://controllers.babylonjs.com/vive/";
    /**
     * File name for the controller model.
     */
    WebXRHTCViveMotionController.MODEL_FILENAME = "wand.babylon";
    return WebXRHTCViveMotionController;
}(WebXRAbstractMotionController));
export { WebXRHTCViveMotionController };
// register the profile
WebXRMotionControllerManager.RegisterController("htc-vive", function (xrInput, scene) {
    return new WebXRHTCViveMotionController(scene, xrInput.gamepad, xrInput.handedness);
});
// WebXRMotionControllerManager.RegisterController("htc-vive-legacy", (xrInput: XRInputSource, scene: Scene) => {
//     return new WebXRHTCViveMotionController(scene, <any>(xrInput.gamepad), xrInput.handedness, true);
// });
var HTCViveLayout = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0,
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {},
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1,
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {},
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1,
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {},
            },
            menu: {
                type: "button",
                gamepadIndices: {
                    button: 4,
                },
                rootNodeName: "menu",
                visualResponses: {},
            },
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "htc_vive_none",
        assetPath: "none.glb",
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0,
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {},
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1,
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {},
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1,
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {},
            },
            menu: {
                type: "button",
                gamepadIndices: {
                    button: 4,
                },
                rootNodeName: "menu",
                visualResponses: {},
            },
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "htc_vive_none",
        assetPath: "none.glb",
    },
    none: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0,
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {},
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1,
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {},
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1,
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {},
            },
            menu: {
                type: "button",
                gamepadIndices: {
                    button: 4,
                },
                rootNodeName: "menu",
                visualResponses: {},
            },
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "htc-vive-none",
        assetPath: "none.glb",
    },
};
//# sourceMappingURL=webXRHTCViveMotionController.js.map